export const DASHBOARD = "Dashboard";
export const WALLET = "Wallet Balance";
export const TRANSACTIONS = "Tranctions";
export const DATA_BANK = "Data Bank";
export const CHART_SUPPORT = "Chat Support";
export const SETTINGS = "Settings";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const SHOW_EVENT = "Show_Event";
export const AUTH_START = "AUTH_START";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const USER_PROFILE = "USER_PROFILE";
export const USER_PROFILE_FAIL = "USER_PROFILE_FAIL";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAILED = "GET_EVENTS_FAILED";
export const GET_SIGNUP_STATUS = "GET_SIGNUP_STATUS";
export const SET_SIGNUP_STATUS = "SET_SIGNUP_STATUS";
export const DASH_VIEW = "DASH_VIEW";
export const LOG_OUT = "LOG_OUT";
export const SET_WORK_EXPERIENCE = "SET_WORK_EXPERIENCE";
export const SET_EDUCATION = "SET_EDUCATION";
export const SET_FUNDRAISING = "SET_FUNDRAISING";
export const SET_WORK_EXPERIENCE_DATABASE = "SET_WORK_EXPERIENCE_DATABASE";
export const SET_EDUCATION_DATABASE = "SET_EDUCATION_DATABASE";
export const EDIT = "EDIT";
export const DASHBOARD_USER_PROFILE = "DASHBOARD_USER_PROFILE";
export const DASHBOARD_USER_PROFILE_FAILED = "DASHBOARD_USER_PROFILE_FAILED";
export const DASHBOARD_LOAD = "DASHBOARD_LOAD";
export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const SEND_APPLICATION = "SEND_APPLICATION";
export const REMOVE_WORK_EXPERIENCE = "REMOVE_WORK_EXPERIENCE";
export const EDIT_WORK_EXPERIENCE = "EDIT_WORK_EXPERIENCE";
export const REMOVE_EDUCATION = "REMOVE_EDUCATION";
export const EDIT_EDUCATION = "EDIT_EDUCATION";
export const UPDATE_STARTUP_DATA = "UPDATE_STARTUP_DATA";
export const UPDATE_STARTUP_INFO = "UPDATE_STARTUP_PROFILE";
export const UPDATE_INVESTOR_DATA = "UPDATE_INVESTOR_DATA";
export const UPDATE_INVESTOR_INFO = "UPDATE_INVESTOR_INFO";
export const UPDATE_PARTNER_INFO = "UPDATE_PARTNER_INFO";
export const SAVE_PARTNER_INFO = "SAVE_PARTNER_INFO";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";
export const UPDATE_MENTOR_DATA = "UPDATE_MENTOR_DATA";
export const UPDATE_MENTOR_INFO = "UPDATE_MENTOR_INFO";
export const UPDATE_STARTUP_USER_PROFILE = "UPDATE_STARTUP_USER_PROFILE";

export const ADD_CRITERIA = "ADD_CRITERIA";
